import freshdeskLogo from "/img/integration/freshdesk.png"
import { ConnectLogo } from "../connect-logo"
import { Form } from "@/components/form/Form.tsx"
import { useFormState } from "@/components/form/form_state.tsx"
import { Input, PasswordInput } from "@/components/form/Input.tsx"
import { Button } from "@/components/ui/button.tsx"
import { useState } from "preact/compat"
import { useLocation } from "wouter-preact"
import { CenterColumnContainer } from "@/components/LoginScreen.tsx"
import { LoadingSpinner } from "@/app/loading"
import { useAsyncEffect } from "@/utils"
import { upsertIntegration as upsertIntegration, getIntegrations, findIntegrationByName } from "@/api/integration"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function ConnectKeheFreshdeskPage(props: any = {}) {
  const redirectTo: string = props.redirectTo ?? "/setup/config/kehe"
  const keheConnectPath: string = props.keheConnectPath ?? "/setup/connect/kehe"
  const [, setLocation] = useLocation()
  const [loading, setLoading] = useState(false)
  const [keheUsername, setKeheUsername] = useState<string | null>(null)
  const [loadingIntegration, setLoadingIntegration] = useState(true)
  const [loginError, setLoginError] = useState<string | null>(null)

  const form = useFormState({
    password: "",
  })

  useAsyncEffect(async () => {
    const res = await getIntegrations()
    if (res.ok) {
      const keheIntegration = findIntegrationByName(res.value.data, "kehe")
      if (keheIntegration) {
        setKeheUsername(keheIntegration.username)
      }
    }
    setLoadingIntegration(false)
  }, [])

  async function onSubmit() {
    if (!keheUsername) return
    setLoading(true)
    setLoginError(null)
    form.set_form_errors([])
    const res = await upsertIntegration("freshdesk", keheUsername, { password: form.password.value })
    setLoading(false)
    if (!res.ok) {
      setLoginError(res.error.message)
      return
    }
    setLocation(redirectTo)
  }

  function handleContinueAnyway() {
    setLocation(redirectTo)
  }

  if (loadingIntegration) {
    return (
      <CenterColumnContainer>
        <div class="flex justify-center py-8">
          <LoadingSpinner />
        </div>
      </CenterColumnContainer>
    )
  }

  if (!keheUsername) {
    return (
      <CenterColumnContainer>
        <div class="text-center py-8">
          <p class="text-gray-500 mb-4">No KeHE integration found. Please connect KeHE first.</p>
          <Button
            class="bg-gray-900 text-white rounded-lg hover:bg-gray-800"
            onClick={() => setLocation(keheConnectPath)}>
            Connect KeHE
          </Button>
        </div>
      </CenterColumnContainer>
    )
  }

  return (
    <CenterColumnContainer>
      <Form class="space-y-6" onSubmit={onSubmit} alerts={form.form_alerts}>
        <ConnectLogo src={freshdeskLogo} alt="Freshdesk" />
        <p class="text-gray-500 text-sm">Enter your FreshDesk credentials to sync your KeHE dispute data.</p>
        <Input label="Username" type="text" name="username" required={true} value={keheUsername} disabled={true} noAutofill />
        <PasswordInput label="Password" required={true} bind={form.password} noAutofill />
        {loginError && (
          <div class="rounded-md bg-red-50 border border-red-200 p-4 space-y-3">
            <p class="text-sm text-red-700">{loginError}</p>
            <div class="flex gap-2">
              <Button
                type="button"
                variant="outline"
                size="sm"
                onClick={handleContinueAnyway}
              >
                Continue Anyway
              </Button>
            </div>
          </div>
        )}
        <div class="flex justify-end">
          <Button
            type="submit"
            class="bg-gray-900 text-white rounded-lg hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2 disabled:bg-gray-300 disabled:cursor-not-allowed"
            disabled={loading}>
            {loading ? "Connecting..." : "Connect Account"}
          </Button>
        </div>
        {loading && <p class="text-sm text-gray-500 text-center">This may take up to 30 seconds</p>}
        <div class="space-y-3 text-sm text-gray-500">
          <p>
            If you login to FreshDesk using Google or another third-party, please convert that account to a
            username/password account by following their password reset flow{" "}
            <a class="text-gray-900 underline" href="https://kehecx.freshdesk.com/support/login" target="_blank">
              here
            </a>
            .
          </p>
          <p>If you don't have a Freshdesk account, let us know and we can ask Kehe to create your account.</p>
        </div>
        <div class="flex justify-end">
          <Button type="button" variant="outline" onClick={() => setLocation(redirectTo)} disabled={loading}>
            Skip
          </Button>
        </div>
      </Form>
    </CenterColumnContainer>
  )
}
